































































































import { NewObject } from "@/helper/shareHelper";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class DropdownComponent extends Vue {
  @Prop({ default: "label" }) readonly label!: string;
  @Prop({ required: true }) readonly options!: Array<any>;
  @Prop({ required: true }) readonly selected!: any | Array<any>;
  @Prop({ required: true }) readonly trackBy!: string;
  @Prop({ default: false }) readonly isLoading!: boolean;
  @Prop({ default: "" }) readonly placeholderSearchText!: string;
  @Prop({ default: "" }) readonly searchBy!: string | Array<string>;
  @Prop({ default: true }) readonly search!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly inputError!: boolean;
  @Prop({ default: false }) readonly multiple!: boolean;

  private selecteDefault: any = "";
  private optionsDefault: any = [];
  private listDisplay: any = [];
  private isShowOptionList = false;
  private addClassHidden = false;
  private searchText = "";
  private selectItemDisplay: any = [];
  private isSetColorOfNewItem = false;
  private idNewItem = 0;

  @Watch("selected", { immediate: true, deep: true })
  selectedChanged(newVal: any, oldVal: any) {
    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
      this.SetDefaultValue();
    }
  }

  @Watch("isLoading", { immediate: true })
  isLoadingChanged(newVal: any, oldVal: any) {
    if (!newVal) {
      this.SetDefaultValue();
    }
  }

  @Watch("options", { immediate: true })
  optionsChanged(newVal: any, oldVal: any) {
    this.SetOptionList();
  }

  @Watch("isShowOptionList")
  isShowOptionListChanged(newVal: any, oldVal: any) {
    this.ToggleBodyOverFlow(newVal);
    if (newVal) {
      this.SetOptionList();
    }
  }

  @Watch("searchText")
  searchTextChanged(newVal: any, oldVal: any) {
    this.optionsDefault = [];
    if (newVal) {
      this.FilterBySearchText(newVal);
    } else {
      this.options.forEach((optionItem: any) => {
        const option = NewObject(optionItem);
        option.activeClass = false;
        this.optionsDefault.push(option);
      });
    }
    this.ResetDatalistDisplay();
  }

  public SetColorOfNewItem(id: number) {
    this.isSetColorOfNewItem = true;
    this.idNewItem = id;
  }

  public HandleScroll() {
    const refListBox: any = this.$refs.listBox;
    const scrollHeight: any = refListBox.scrollHeight;
    const scrollTop: any = refListBox.scrollTop;
    const clientHeight: any = refListBox.clientHeight;
    const scroll = scrollHeight - (scrollTop + clientHeight);
    if (scroll < 300) {
      if (this.listDisplay.length < this.optionsDefault.length) {
        this.listDisplay.push(this.optionsDefault[this.listDisplay.length]);
      }
    }
  }

  public ResetDatalistDisplay() {
    this.listDisplay = [];
    for (let i = 0; i < (this.multiple ? 50 : 10); i++) {
      if (i < this.optionsDefault.length) {
        this.listDisplay.push(this.optionsDefault[i]);
      }
    }
  }

  public SetOptionList() {
    if (this.selected.length === undefined || (this.selected.length === 0 && this.idNewItem === 0)) {
      this.optionsDefault = [];
      if (this.options.length > 0) {
        this.options.forEach((optionItem: any) => {
          const option = NewObject(optionItem);
          option.activeClass = false;
          this.optionsDefault.push(option);
        });
        if (this.multiple) {
          this.optionsDefault.sort((a: any, b: any) => (a.tagId > b.tagId ? -1 : 1));
        }
        this.ResetDatalistDisplay();
        this.SetDefaultValue();
      }
    } else if (this.selected.length >= 0 && this.idNewItem !== 0) {
      if (this.options.length > 0) {
        const newItem = this.options.find((x) => x.tagId === this.idNewItem);
        newItem.activeClass = false;
        this.optionsDefault.push(newItem);
        this.listDisplay.push(newItem);
        this.listDisplay.sort((a: any, b: any) => (a.tagId > b.tagId ? -1 : 1));
      }
    }
  }

  public SetDefaultValue() {
    if (!this.isLoading) {
      if (this.multiple) {
        if (this.selected.length > 0) {
          const selectList: any = [];
          this.selected.forEach((selectItem: any) => {
            const select = this.options.find((x) => x[this.trackBy] === selectItem[this.trackBy]);
            selectList.push(select);
          });
          this.selecteDefault = selectList;
        } else {
          this.selecteDefault = [];
        }
      } else {
        if (this.selected[this.trackBy] !== undefined && this.optionsDefault.length > 0) {
          this.optionsDefault.forEach((item: any) => {
            if (this.selected[this.trackBy] == item[this.trackBy]) {
              item.activeClass = true;
              const object = NewObject(item);
              delete object.activeClass;
              this.selecteDefault = object;
              this.SelectedOption();
            } else {
              item.activeClass = false;
            }
          });
        } else {
          this.selecteDefault = "";
        }
      }
    }
  }
  public ChooseThis(indexValue: number) {
    this.optionsDefault.forEach((item: any, index: number) => {
      if (index == indexValue) {
        item.activeClass = true;
      } else {
        item.activeClass = false;
      }
    });

    const selectItem = this.optionsDefault.find((item: any) => item.activeClass);
    this.$emit("ChooseThis", NewObject(selectItem));
  }
  public ChooseMultiple(indexValue: number) {
    this.listDisplay.forEach((item: any, index: number) => {
      if (index == indexValue) {
        item.activeClass = true;
        this.selectItemDisplay.push(item);
      }
    });

    this.listDisplay = this.listDisplay.filter((item: any) => item.activeClass == false);
  }
  public DeSelect(id: number) {
    this.optionsDefault.forEach((item: any) => {
      if (item.tagId == id) {
        item.activeClass = false;
        this.listDisplay.push(item);
      }
    });
    this.listDisplay = this.optionsDefault.filter((item: any) => item.activeClass == false);
    this.selectItemDisplay = this.optionsDefault.filter((item: any) => item.activeClass);
  }
  public SelectedOption() {
    const selected = this.optionsDefault.find((option: any) => option.activeClass);
    if (selected) {
      const object = NewObject(selected);
      delete object.activeClass;
      this.$emit("update:selected", object);
      this.$emit("change", object);
    }
  }
  public SelectedOptionMultiple() {
    const selected = this.optionsDefault.filter((option: any) => option.activeClass);
    if (selected) {
      delete selected.activeClass;
      this.$emit("update:selected", selected);
      this.$emit("change", selected);
    }
  }
  public ToggleShowOptionList() {
    if (!this.disabled && !this.isLoading) {
      this.isShowOptionList = this.isShowOptionList ? false : true;
      if (this.isShowOptionList) {
        this.$nextTick(() => {
          const refListBox: any = this.$refs.listBox;
          refListBox.addEventListener("scroll", this.HandleScroll);
        });
      }
    }
  }
  public ToggleBodyOverFlow(value: boolean) {
    const showBgModalList = document.querySelectorAll(".showBgModal");
    const el = document.body;
    if (value) {
      el.style.overflow = "hidden";
      showBgModalList.forEach((item: any) => {
        item.style.display = "block";
      });
    } else {
      el.style.overflow = "auto";
      showBgModalList.forEach((item: any) => {
        item.style.display = "none";
      });
    }
  }

  public HiddenOptionList(isDeSelect = false) {
    this.idNewItem = 0;
    this.isSetColorOfNewItem = false;
    if (this.multiple && isDeSelect) {
      const selectedIdList: any = [];
      this.selected.forEach((item: any) => {
        selectedIdList.push(item.tagId);
      });
      this.optionsDefault.forEach((item: any) => {
        if (item.activeClass == true) {
          if (!selectedIdList.includes(item.tagId)) {
            item.activeClass = false;
          }
        } else if (selectedIdList.includes(item.tagId)) {
          item.activeClass = true;
        }
      });
      this.listDisplay = this.optionsDefault.filter((item: any) => item.activeClass == false);
      this.selectItemDisplay = this.optionsDefault.filter((item: any) => item.activeClass);
    }
    this.addClassHidden = true;
    const refListBox: any = this.$refs.listBox;
    refListBox.removeEventListener("scroll", this.HandleScroll);
    setTimeout(() => {
      this.isShowOptionList = false;
      this.addClassHidden = false;
      this.searchText = "";
    }, 300);
  }

  public FilterBySearchText(searchText: string) {
    let optionsFilter: any = [];
    if (this.searchBy) {
      optionsFilter = this.options.filter((option: any) => {
        if (Array.isArray(this.searchBy)) {
          let optionSearch = "";
          this.searchBy.forEach((searchItem: string) => {
            if (option[searchItem]) {
              optionSearch += option[searchItem].toLowerCase();
            }
          });

          return optionSearch.toLowerCase().includes(searchText.toLowerCase());
        } else {
          if (option[this.searchBy]) {
            return option[this.searchBy].toLowerCase().includes(searchText.toLowerCase());
          } else {
            return [];
          }
        }
      });
    } else {
      optionsFilter = this.options;
    }

    optionsFilter.forEach((optionItem: any) => {
      const option = NewObject(optionItem);
      if (optionItem[this.trackBy] == this.selected[this.trackBy]) {
        option.activeClass = true;
      } else {
        option.activeClass = false;
      }

      this.optionsDefault.push(option);
    });
  }

  destroyed() {
    const showBgModalList = document.querySelectorAll(".showBgModal");
    const el = document.body;
    el.style.overflow = "auto";
    showBgModalList.forEach((item: any) => {
      item.style.display = "none";
    });
  }
}
